import { render, staticRenderFns } from "./result.vue?vue&type=template&id=80b5a2ac&scoped=true&"
import script from "./result.vue?vue&type=script&lang=js&"
export * from "./result.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./result.vue?vue&type=style&index=0&id=80b5a2ac&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "80b5a2ac",
  "5d9be7f2"
  
)

export default component.exports